// extracted by mini-css-extract-plugin
module.exports = {"WinnerMessageBlock":"PlayerWinMessage_WinnerMessageBlock__1YHGZ"};